// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"_2So8750SU7UNjN6r7zBJqB","alert":"uPam-ytAKYTQ6veZ3PMQ7","profileCard":"_3qn2sSjzbCx8KPH6EofPdo"};